import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { SURVEYS } from '@hotjar/webapp/constants/routes';
import { useCurrentSite } from '@hotjar/site';

export const useNavigateToSurveyResponse = (
  surveyId: number,
): ((responseId: number | null) => void) => {
  const { data: site } = useCurrentSite();
  const navigate = useNavigate();
  const selectResponse = useCallback(
    (responseId: number | null) => {
      if (!site) return;

      const route = responseId
        ? getRoute(SURVEYS.RESPONSE.path, {
            siteId: site.id,
            surveyId,
            prid: responseId,
          })
        : getRoute(SURVEYS.RESPONSES.path, {
            siteId: site.id,
            surveyId,
          });

      navigate(route, {
        replace: true,
      });
    },
    [navigate, site, surveyId],
  );

  return selectResponse;
};
